/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Month_MarchInputs */

const he_month_march = /** @type {(inputs: Month_MarchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מרץ`)
};

const en_month_march = /** @type {(inputs: Month_MarchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`March`)
};

/**
* | output |
* | --- |
* | "March" |
*
* @param {Month_MarchInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const month_march = /** @type {((inputs?: Month_MarchInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Month_MarchInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_month_march(inputs)
	return en_month_march(inputs)
});